import { useRef, useState } from 'react';
import methodModel from '../../methods/methods';
import './CardAnimationStyle.css';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import environment from '../../environment';

const CardAnimation = ({ detail }) => {
    var right = document.getElementsByClassName("right");
    const si = useRef(right.length);
    var z = 1;
    const [currentIndex, setCurrentIndex] = useState(1);
    const [loader, setLoader] = useState(false);

    // Left Side Image CSS
    const textElementStyle = {
        position: 'absolute',
        top: `${detail?.textPosition?.top}%`,
        right: `${detail?.textPosition?.right}%`,
        fontSize: `${detail?.textSize}px`,
        color: detail?.textColor,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const imageElementStyle = {
        position: 'absolute',
        top: `${detail?.imagePosition?.top}%`,
        right: `${detail?.imagePosition?.right}%`,
        width: `${detail?.imageSize}%`,
        cursor: 'default',
    };
    const text2ElementStyle = {
        position: 'absolute',
        top: `${detail?.text2Position?.top}%`,
        right: `${detail?.text2Position?.right}%`,
        fontSize: `${detail?.text2Size}px`,
        color: detail?.text2Color,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const stickerStampElementStyle = {
        position: 'absolute',
        top: `${detail?.stickerStampPosition?.top}%`,
        right: `${detail?.stickerStampPosition?.right}%`,
        width: `${detail?.stickerStampSize}%`,
        cursor: 'default',
    };

    // Right Side Image CSS
    const secondImageTextElementStyle = {
        position: 'absolute',
        top: `${detail?.secondImageTextPosition?.top}%`,
        right: `${detail?.secondImageTextPosition?.right}%`,
        fontSize: `${detail?.secondImageTextSize}px`,
        color: detail?.secondImageTextColor,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const secondImageElementStyle = {
        position: 'absolute',
        top: `${detail?.secondImagePosition?.top}%`,
        right: `${detail?.secondImagePosition?.right}%`,
        width: `${detail?.secondImageSize}%`,
        cursor: 'default',
    };
    const secondImageText2ElementStyle = {
        position: 'absolute',
        top: `${detail?.secondImageText2Position?.top}%`,
        right: `${detail?.secondImageText2Position?.right}%`,
        fontSize: `${detail?.secondImageText2Size}px`,
        color: detail?.secondImageText2Color,
        height: 'auto',
        cursor: 'default',
        userSelect: 'none',
        textAlign: 'center',
        lineHeight: 'normal',
    };
    const secondImageStickerStampElementStyle = {
        position: 'absolute',
        top: `${detail?.secondImageStickerStampPosition?.top}%`,
        right: `${detail?.secondImageStickerStampPosition?.right}%`,
        width: `${detail?.secondImageStickerStampSize}%`,
        cursor: 'default',
    };

    const turnLeft = () => {
        setLoader(true)
        if (si.current < right.length) {
            si.current++;
        }
        else {
            si.current = 1;
            for (var i = right.length - 1; i > 0; i--) {
                right[i].classList.add("flip");
                right[i].style.zIndex = right.length + 1 - i;
            }
        }
        right[si.current - 1].className = "right";
        setTimeout(function () { right[si.current - 1].style.zIndex = "auto"; }, 350);
        setCurrentIndex(currentIndex - 1);
        setTimeout(() => {
            setLoader(false)
        }, 1000);
    };

    const turnRight = () => {
        setLoader(true)
        if (si.current >= 1) {
            si.current--;
        }
        else {
            si.current = right.length - 1;
            function sttmot(i) {
                setTimeout(function () { right[i].style.zIndex = "auto"; }, 300);
            }
            for (var i = 0; i < right.length; i++) {
                right[i].className = "right";
                sttmot(i);
                z = 1;
            }
        }
        right[si.current].classList.add("flip");
        z++;
        right[si.current].style.zIndex = currentIndex === 2 ? "5" : z;
        setCurrentIndex(currentIndex + 1);
        setTimeout(() => {
            setLoader(false)
        }, 1000);
    };

    const rightPosition = currentIndex === 1 ? "170px" : currentIndex === 3 ? "-170px" : "0";

    const waterMark = () => {
        return ""
        return <div className="absolute inset-0 pointer-events-none grid grid-cols-4 grid-rows-4 gap-4" style={{ opacity: 0.2 }}>
            {Array(16).fill(0).map((_, i) => (
                <span key={i} className="text-primary text-2xl font-bold select-none transform -rotate-45 flex items-center justify-center">
                    FRUM ME 2 U
                </span>
            ))}
        </div>
    }

    return (
        <>
            <div className="new-section">
                <div className="book-section">
                    <div className="container  relative">
                        <div className="right" style={{ right: rightPosition }}>
                            {/* Fourth Image */}
                            <figure 
                            className="back !bg-[#f2f2f2]" 
                            id="back-cover"
                            style={{ backgroundImage: "/assets/img/white-screen.jpg" }}
                            >
                                {waterMark()}
                                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                    <div className="relative w-52 h-52 ">
                                        <img src="/assets/img/black_heart.png" alt="Heart" className="w-full h-full object-contain" />
                                        <p className="absolute inset-0 flex items-center justify-center -top-3 text-black text-center text-sm font-semibold py-4 px-6">
                                            Touching One Heart At A Time
                                        </p>
                                    </div>
                                </div>
                                <div className="absolute bottom-3 left-4 transform text-white text-sm text-right px-2">
                                    <p className="text-md font-semibold text-gray-900"><span className='text-md'>©</span> Copyright</p>
                                </div>
                                <div className="absolute bottom-3 right-4 transform  text-white text-sm text-right  px-2">
                                    <p className="text-md font-semibold text-gray-900">FRUM ME 2 U</p>
                                    <p className="text-[12px] font-medium text-gray-800">{environment.frontendUrl}</p>
                                </div>
                            </figure>
                            {/* Third Image */}
                            <figure className="front">
                                <div className="relative w-full h-full">
                                    <img src={methodModel.noImg(`${detail?.secondImage}`)} className="h-full mx-auto object-cover w-full" id="image" />
                                    {waterMark()}
                                    <div style={secondImageTextElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: detail?.secondImageText }}></div>
                                    {detail?.secondImageStickerImage && <img style={secondImageElementStyle} src={detail?.secondImageStickerImage ? methodModel.userImg(detail?.secondImageStickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                    {detail?.secondImageText2 && <div style={secondImageText2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: detail?.secondImageText2 }}></div>}
                                    {detail?.secondImageStickerStamp && <img style={secondImageStickerStampElementStyle} src={methodModel.noImg(detail?.secondImageStickerStamp)} className={`p-1`} />}
                                </div>
                            </figure>
                        </div>
                        <div className="right" style={{ right: rightPosition }}>
                            {/* Second Image */}
                            <figure className="back">
                                <div className="relative w-full h-full">
                                    <img src={methodModel.noImg(`${detail?.image}`)} className="h-full mx-auto object-cover" id="image" />
                                    {waterMark()}
                                    <div style={textElementStyle} className={`p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: detail?.text }}></div>
                                    {detail?.stickerImage && <img style={imageElementStyle} src={detail?.stickerImage ? methodModel.userImg(detail?.stickerImage) : "/assets/img/placeholder.png"} className={`p-1`} />}
                                    {detail?.text2 && <div style={text2ElementStyle} className={`p-1`} dangerouslySetInnerHTML={{ __html: detail?.text2 }}></div>}
                                    {detail?.stickerStamp && <img style={stickerStampElementStyle} src={methodModel.noImg(detail?.stickerStamp)} className={`p-1`} />}
                                </div>
                            </figure>
                            {/* First Image */}
                            <figure
                                className="front"
                                id="cover"
                                style={{ backgroundImage: `url(${methodModel.noImg(detail?.envelopeId?.front_image || detail?.categoryId?.image)})` }}
                            >
                                {waterMark()}
                            </figure>
                        </div>
                    </div>

                    {/* Navigation Buttons */}
                    <div className="flex gap-2 items-center justify-center">
                        <button
                            type="button"
                            onClick={turnLeft}
                            disabled={loader || currentIndex === 1}
                            className="disabled:cursor-not-allowed h-10 w-10 rounded-full bg-gray-100 hover:bg-gray-200"
                        >
                            <FaArrowLeft />
                        </button>
                        {/* Progress Bar */}
                        <div className="w-96 bg-gray-200 rounded-full h-2.5 my-4">
                            <div
                                className="bg-primary h-2.5 rounded-full transition-all duration-300"
                                style={{ width: `${(currentIndex - 1) * 50}%` }}
                            />
                        </div>
                        <button
                            type="button"
                            onClick={turnRight}
                            disabled={loader || currentIndex === 3}
                            className="disabled:cursor-not-allowed h-10 w-10 rounded-full bg-gray-100 hover:bg-gray-200"
                        >
                            <FaArrowRight />
                        </button>
                    </div>
                </div>
            </div>

        </>
    );
};

export default CardAnimation;